import { useEffect, useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { formatCurrency } from "../helpers/utils";

export default function OrderDetailsModal({
  show,
  handleClose,
  initialData = null,
  loading = false,
}) {
  const [order, setOrder] = useState(initialData);

  useEffect(() => {
    if (show) setOrder(initialData);
  }, [show, initialData]);

  const productCount = useMemo(
    () => (Array.isArray(order?.products) ? order.products.length : 0),
    [order]
  );

  console.log(order);

  // ✅ E-Barimt text (PERSON/COMPANY)
  const ebarimtText = useMemo(() => {
    const t = order?.ebarimtType;
    if (t === "PERSON") return "Хувь хүн";
    if (t === "COMPANY") return order?.ebarimtRegister || "Байгууллага";
    return "-";
  }, [order]);

  // ✅ 58мм HTML print (шинэ цонхонд)
  const handlePrint58mm = () => {
    if (!order) return;

    const w = window.open("", "_blank");
    if (!w) {
      alert("Pop-up blocked байна. Browser дээр Pop-ups allow хийнэ үү.");
      return;
    }

    const products = Array.isArray(order?.products) ? order.products : [];

    const itemsHtml =
      products.length > 0
        ? products
            .map((p, i) => {
              const name = p?.name || "-";
              const price = Number(p?.price || 0);
              const qty = Number(p?.quantity || 0);
              const amount = Number(p?.amount ?? price * qty);

              return `
                <div class="item">
                  <div class="item-name"><b>${i + 1}. ${escapeHtml(
                name
              )}</b></div>

                  <div class="item-line">
                    <div class="left">${escapeHtml(
                      formatCurrency(price)
                    )} × ${qty}</div>
                    <div class="right">${escapeHtml(
                      formatCurrency(amount)
                    )}</div>
                  </div>
                </div>
              `;
            })
            .join("")
        : `<div class="muted">Бараа байхгүй</div>`;

    // ✅ totalAmount (order дээр байгааг нь хамгийн түрүүнд ашиглана)
    const computedTotal = products.reduce((sum, p) => {
      const price = Number(p?.price || 0);
      const qty = Number(p?.quantity || 0);
      const amount = Number(p?.amount ?? price * qty);
      return sum + amount;
    }, 0);

    const totalAmount =
      Number(order?.totalAmount ?? order?.total ?? 0) || computedTotal;

    const orderCode = order?.orderCode ? `#${order.orderCode}` : `#${order?.id}`;
    const createdAt = order?.createdAt || "-";
    const statusName = order?.status?.name || "-";
    const phone = order?.phone || "-";
    const address = `${order?.district?.name ? order.district.name + " " : ""}${
      order?.address || "-"
    }`;

    const html = `
<!doctype html>
<html>
<head>
  <meta charset="utf-8" />
  <title>58mm</title>
  <style>
    /* ✅ 58мм яг тааруулах */
    @page { size: 58mm auto; margin: 0; }

    html, body {
      margin: 0;
      padding: 0;
      width: 58mm;
      background: #fff;
    }

    body {
      padding: 3mm 3mm;
      font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono","Courier New", monospace;
      font-size: 12px;
      line-height: 1.25;
      color: #000;

      /* ✅ бүдэгрэхээс хамгаална */
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      text-rendering: geometricPrecision;
      -webkit-font-smoothing: none;
      font-smooth: never;
      letter-spacing: 0.1px;
    }

    .receipt { width: 58mm; }

    .center { text-align: center; }
    .title { font-size: 14px; font-weight: 900; margin: 0 0 6px 0; }
    .divider { border-top: 1px dashed #000; margin: 6px 0; }

    .meta {
      font-size: 11px;
      margin: 2px 0;
      display: flex;
      justify-content: space-between;
      gap: 6px;
    }

    /* ✅ Бүтэн тод */
    .muted { font-size: 11px; }

    .item { margin: 6px 0; }
    .item-name { margin-bottom: 2px; }

    /* ✅ баруун талын дүн fixed / right align */
    .item-line {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      gap: 6px;
      font-size: 12px;
    }
    .left { flex: 1; }
    .right {
      min-width: 20mm;
      text-align: right;
      font-weight: 900;
    }

    .total-line {
      display: flex;
      justify-content: space-between;
      font-size: 13px;
      font-weight: 900;
    }
  </style>
</head>

<body>
  <div class="receipt">
    <div class="center title">Захиалгын баримт</div>

    <div class="meta"><div>Огноо</div><div>${escapeHtml(
      createdAt
    )}</div></div>
    <div class="meta"><div>Төлөв</div><div>${escapeHtml(
      statusName
    )}</div></div>

    <div class="divider"></div>

    <div class="meta"><div>Утас</div><div><b>${escapeHtml(
      phone
    )}</b></div></div>
    <div class="meta"><div>И-Баримт</div><div><b>${escapeHtml(
      ebarimtText
    )}</b></div></div>
    <div class="meta"><div>Хаяг</div><div style="text-align:right; max-width:34mm;"><b>${escapeHtml(
      address
    )}</b></div></div>

    <div class="divider"></div>

    ${itemsHtml}

    <div class="divider"></div>

    <div class="total-line">
      <div>НИЙТ</div>
      <div>${escapeHtml(formatCurrency(totalAmount))}</div>
    </div>

    <div class="divider"></div>
    <div class="center muted">Баярлалаа 🙏</div>

    <script>
      // ✅ Preview нээгдээд render болсны дараа хэвлэнэ
      window.onload = function () {
        setTimeout(function(){
          window.focus();
          window.print();
          setTimeout(function(){ window.close(); }, 400);
        }, 250);
      };
    </script>
  </div>
</body>
</html>
`;

    w.document.open();
    w.document.write(html);
    w.document.close();
  };

  return (
    <>
      {/* PRINT CSS: Screen дээр чек харагдахгүй, зөвхөн print үед гарна */}
      <style>
        {`
/* Screen дээр print хэсгийг бүрэн нуух */
.print-only { display: none; }

@media print {
  /* Header/Footer зэрэг screen UI-г нуух */
  .no-print { display: none !important; }

  /* Бусад бүх UI-г нуух */
  body * { visibility: hidden !important; }

  /* Зөвхөн чек хэвлэнэ */
  .print-only, .print-only * {
    display: block !important;
    visibility: visible !important;
  }

  /* 58мм page */
  @page { size: 58mm auto; margin: 0; }

  .print-only {
    width: 58mm;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono","Courier New", monospace;
    font-size: 12px;
    line-height: 1.2;
    padding: 4mm;
    position: absolute;
    left: 0;
    top: 0;
  }

  .pr-title {
    text-align: center;
    font-weight: 700;
    font-size: 14px;
    margin: 0 0 6px 0;
  }

  .pr-row {
    display: flex;
    justify-content: space-between;
    gap: 6px;
    margin: 2px 0;
  }

  .pr-divider { border-top: 1px dashed #000; margin: 6px 0; }
  .pr-muted { opacity: 0.85; }
  .pr-strong { font-weight: 700; }
  .pr-center { text-align: center; }
  .pr-small { font-size: 11px; }
}
        `}
      </style>

      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton className="no-print">
          <Modal.Title>
            Захиалгын дэлгэрэнгүй{" "}
            {order?.orderCode ? `#${order.orderCode}` : ""}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {loading ? (
            <div className="text-center py-3 no-print">
              <span className="spinner-border spinner-border-sm me-2" />
              Уншиж байна...
            </div>
          ) : !order ? (
            <div className="text-center py-3 no-print">Мэдээлэл олдсонгүй</div>
          ) : (
            <>
              {/* =================== SCREEN VIEW =================== */}
              <div className="no-print">
                <div className="row g-2 mb-3">
                  <div className="col-6">
                    <div className="text-muted">Огноо</div>
                    <div>{order.createdAt || "-"}</div>
                  </div>

                  <div className="col-6">
                    <div className="text-muted">Төлөв</div>
                    <div>{order?.status?.name || "-"}</div>
                  </div>

                  <div className="col-12">
                    <div className="text-muted">Хаяг</div>
                    <div>
                      {order?.district?.name ? `${order.district.name} ` : ""}
                      {order.address || "-"}
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="text-muted">Утас</div>
                    <div>{order.phone || "-"}</div>
                  </div>

                  {/* ✅ E-Barimt (screen) */}
                  <div className="col-6">
                    <div className="text-muted">И-Баримт</div>
                    <div className="fw-bold">{ebarimtText}</div>
                  </div>

                  <div className="col-6">
                    <div className="text-muted">Нийт дүн</div>
                    <div className="fw-semibold">
                      {formatCurrency(order.totalAmount || 0)}
                    </div>
                  </div>
                </div>

                <hr />

                <div className="d-flex align-items-center justify-content-between mb-2">
                  <div className="fw-semibold">Бараанууд</div>
                  <div className="text-muted">{productCount} ширхэг</div>
                </div>

                {Array.isArray(order.products) && order.products.length ? (
                  <div className="table-responsive">
                    <table className="table table-sm mb-0">
                      <thead>
                        <tr>
                          <th>Бараа</th>
                          <th className="text-center">Тоо</th>
                          <th className="text-end">Үнэ</th>
                          <th className="text-end">Дүн</th>
                        </tr>
                      </thead>
                      <tbody>
                        {order.products.map((p, idx) => (
                          <tr key={`${p.id}-${idx}`}>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <img
                                  src={p.image}
                                  alt={p.name}
                                  style={{
                                    width: 36,
                                    height: 36,
                                    objectFit: "cover",
                                    borderRadius: 6,
                                  }}
                                />
                                <div>{p.name}</div>
                              </div>
                            </td>
                            <td className="text-center">{p.quantity}</td>
                            <td className="text-end">
                              {formatCurrency(p.price)}
                            </td>
                            <td className="text-end">
                              {formatCurrency(p.amount)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-muted">Бараа байхгүй</div>
                )}
              </div>

              {/* =================== PRINT VIEW (58mm) =================== */}
              <div className="print-only">
                <div className="pr-title">Бөөний түгээлт</div>

                <div className="pr-row pr-muted pr-small">
                  <span>Захиалга</span>
                  <span>
                    {order?.orderCode ? `#${order.orderCode}` : `#${order.id}`}
                  </span>
                </div>

                <div className="pr-row pr-muted pr-small">
                  <span>Огноо</span>
                  <span>{order.createdAt || "-"}</span>
                </div>

                <div className="pr-row pr-muted pr-small">
                  <span>Төлөв</span>
                  <span>{order?.status?.name || "-"}</span>
                </div>

                <div className="pr-divider" />

                <div className="pr-row pr-small">
                  <span>Утас</span>
                  <span>{order.phone || "-"}</span>
                </div>

                {/* ✅ E-Barimt (print) */}
                <div className="pr-row pr-small">
                  <span>И-Баримт</span>
                  <span>{ebarimtText}</span>
                </div>

                <div className="pr-row pr-small">
                  <span>Хаяг</span>
                  <span>
                    {(order?.district?.name ? `${order.district.name} ` : "") +
                      (order.address || "-")}
                  </span>
                </div>

                <div className="pr-divider" />

                {/* PRODUCTS: Нэрний доор "үнэ × тоо = дүн" */}
                {Array.isArray(order.products) && order.products.length ? (
                  order.products.map((p, idx) => (
                    <div key={`${p.id}-${idx}`} style={{ marginBottom: 6 }}>
                      {/* Нэр */}
                      <div className="pr-row">
                        <span className="pr-strong">{p.name}</span>
                      </div>

                      {/* үнэ × тоо = дүн */}
                      <div className="pr-row pr-small pr-muted">
                        <span>
                          {formatCurrency(p.price)} × {p.quantity}
                        </span>
                        <span className="pr-strong">
                          {formatCurrency(p.amount)}
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="pr-row">
                    <span>Бараа</span>
                    <span>-</span>
                  </div>
                )}

                <div className="pr-divider" />

                <div className="pr-row pr-strong">
                  <span>НИЙТ</span>
                  <span>{formatCurrency(order.totalAmount || 0)}</span>
                </div>

                <div className="pr-divider" />

                <div className="pr-center pr-small pr-muted">
                  Баярлалаа 🙏
                </div>
              </div>
            </>
          )}
        </Modal.Body>

        <Modal.Footer className="no-print">
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Болих
          </Button>

          {/* ✅ ЭНЭ товч одоо window.print биш, шинэ цонхоор 58мм хэвлэнэ */}
          <Button
            variant="primary"
            onClick={handlePrint58mm}
            disabled={loading || !order}
          >
            Хэвлэх (58мм)
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

function escapeHtml(str) {
  return String(str ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}
